import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { Store } from 'store/storeTypes';
import TimeViewModeToggle from './TimeViewModeToggle';
import { setTimeViewMode } from 'actions/userUiActions';
import {
  isTimeViewModeResolvedSelector,
  isTimeViewModeToggleVisibleSelector,
  timeViewModeSelector,
} from 'reducers/ui/timeViewModeUiReducer';
import { isAnyProductionHoursSetSelector } from 'reducers/productionHoursApiReducer';

const mapStateToProps = (state: Store) => ({
  timeViewMode: timeViewModeSelector(state),
  isVisible: isTimeViewModeToggleVisibleSelector(state),
  isProductionHoursConfigured: isAnyProductionHoursSetSelector(state),
  isLoading: !isTimeViewModeResolvedSelector(state),
});

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators({ setTimeViewMode }, dispatch);

export type TimeViewModeToggleProps = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps>;

export default connect(mapStateToProps, mapDispatchToProps)(TimeViewModeToggle);
